import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from './sessionStorage';
import { getAuthToken } from './auth';
import { UnauthorizedPath } from './components/Common/Products/ProductsRoute';
import * as Sentry from "@sentry/react";

// wrappers for http requests
// will include user access token by default

export const httpRequest = {
  get,
  post,
  put
}

const request = async (method, url, body = '') => {
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const headers = {
    "Authorization": `Bearer ${getAuthToken()}`,
    'X-Session-ID': accountObj && accountObj.sessionId,
  };

  if (method !== "GET") { headers["Content-Type"] = "application/json"; }

  let options = {
    method,
    headers,
  };

  if (method !== 'GET') {
    options = {
      ...options,
      body: body ? JSON.stringify(body) : ''
    }
  }

  Sentry.addBreadcrumb({
    category: "http",
    type: "request",
    data: { method, url },
    level: Sentry.Severity.Info,
  });

  let response;

  try {
    response = await fetch(url, options);
  } catch (networkErr) {
    Sentry.captureException(networkErr, {
      tags: {
        component: "httpRequest",
        network: true
      },
      extra: {
        method,
        url,
        options
      },
    });
    console.error("Network error during fetch", networkErr);
    throw networkErr;
  }

  Sentry.addBreadcrumb({
    category: "http",
    type: "response",
    data: {
      method,
      url,
      status: response.status,
    },
    level: Sentry.Severity.Info,
  });

  return handleResponse(response, { method, url });
};

function get(url) {
  return request("GET", url);
}

function post(url, body) {
  return request('POST', url, body)
}

function put(url, body) {
  return request('PUT', url, body)
}

// non-exported helpers

const isJsonParsable = (text) => {
  try {
    JSON.parse(text);
  } catch (e) {
    return false;
  }
  return true;
}

function handleResponse(response, ctx) {
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.includes("application/pdf")) {
    return response;
  }
  return response.text().then(text => {

    const responseJson = {
      status: response.status,
      statusText: response.statusText,
      url: response.url,
      headers: (() => {
        const h = {};
        response.headers.forEach((v, k) => (h[k] = v));
        return h;
      })(),
      fullResponse: JSON.stringify(response),
    };

    if (!isJsonParsable(text) && !response.ok) {
      Sentry.captureMessage("Invalid response message", {
        level: "warning",
        extra: { 
          status: response.status, 
          rawText: text, 
          response: responseJson,
          ...ctx 
        },
      });

      checkStatusCode(responseJson, ctx);
      return Promise.reject('Invalid response message');
    }

    const data = text && JSON.parse(text);

    if (!response.ok) {
      Sentry.captureMessage(`HTTP ${response.status} response`, {
        level: "warning",
        extra: { 
          status: response.status, 
          data, 
          response: responseJson,
          ...ctx 
        },
      });

      const error = (data && data.message) || response.statusText;

      checkStatusCode(responseJson, ctx);
      return Promise.reject(error);
    }

    return data;
  });
}

function checkStatusCode(response, ctx) {
  switch (response.status) {
    case 403:
      Sentry.captureMessage("403 - redirect UnauthorizedPath", {
        level: "warning",
        extra: {
          ...ctx,
          response,
          status: 403
        },
      });
      window.location.href = UnauthorizedPath;
      break;
    case 401:
      Sentry.captureMessage("401 - redirect /ns", {
        level: "warning",
        extra: {
          ...ctx,
          response,
          status: 401
        },
      });
      window.location.href = '/ns';
      break;
    default:
      break;
  }
}



// WEBPACK FOOTER //
// ./src/httpRequest.js